import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=59529038&scoped=true&"
import script from "./SwitchLanguage.vue?vue&type=script&lang=ts&"
export * from "./SwitchLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59529038",
  null
  
)

export default component.exports